import { get } from "@ember/object";
import type { ValidationFunction } from "core/validators";

// This validator is from https://github.com/skaterdav85/ember-changeset-conditional-validations/

export default function validateSometimes(validators, condition) {
  if (Array.isArray(validators)) {
    return validators.map(guardValidatorWithCondition);
    // eslint-disable-next-line no-else-return
  } else {
    return guardValidatorWithCondition(validators);
  }

  function guardValidatorWithCondition(validator: ValidationFunction) {
    return function (key, newValue, oldValue, changes, content) {
      const thisValue = {
        get(property) {
          return get(changes, property) != null
            ? get(changes, property)
            : get(content, property);
        }
      };

      if (condition.call(thisValue, changes, content)) {
        return validator(key, newValue, oldValue, changes, content);
      }
      return true;
    };
  }
}
